<template>
  <b-row>
    <b-form-group label="Cliente">
      <b-input-group>
        <b-form-input v-model="model" :required="required"></b-form-input>
        <b-input-group-prepend>
          <span class="p-inputgroup-addon" v-if="model">
            <img
              fluid
              :src="iconClear"
              style="height: 15px; width: 15px; cursor: pointer"
              @click="clearPerson"
            />
          </span>
        </b-input-group-prepend>
        <b-input-group-prepend>
          <span class="ml-3">
            <img
              fluid
              :src="iconSearch"
              style="height: 30px; width: 30px; cursor: pointer"
              @click="modal"
            />
          </span>
        </b-input-group-prepend>
      </b-input-group>
    </b-form-group>
  </b-row>
  <Sidebar v-model:visible="visible" position="left" class="p-sidebar-lg">
    <b-card class="mt-2">
      <b-form @submit="filtrar">
        <b-row>
          <b-form-group label="Pessoa" class="col-md-12 col-sm-6 col-lg-12">
            <b-form-input v-model="form.nome"></b-form-input>
          </b-form-group>
          <b-form-group
            label="CNPJ ou CPF"
            class="col-md-12 col-sm-6 col-lg-12"
          >
            <b-form-input v-model="form.cnpjcpf"></b-form-input>
          </b-form-group>
        </b-row>
        <b-row class="text-end">
          <b-col class="mb-3">
            <b-button class="ml-2" type="submit" variant="primary">
              Filtrar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <b-table selectable small :items="items" :fields="fields" responsive>
        <template #cell(Ações)="data">
          <b-button-group>
            <b-button
              class="ml-2"
              pill
              variant="transparent"
              @click="onChangePerson(data.item)"
            >
              <img
                fluid
                :src="iconCheck"
                style="height: 30px; width: 30px; cursor: pointer"
                @click="modal"
              />
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </b-card>
  </Sidebar>
</template>

<script>
import service from '@/services/BaseService'
import iconSearch from '@/icons/search.png'
import iconCheck from '@/icons/check.png'
import iconClear from '@/icons/clear.png'
import qs from 'qs'
export default {
  emits: ['onChangePerson'],
  props: ['required', 'id'],
  setup() {
    return {
      iconSearch,
      iconCheck,
      iconClear,
    }
  },
  data() {
    return {
      model: null,
      items: [],
      form: {},
      fields: [
        { key: 'id', label: 'id' },
        { key: 'cliente', label: 'Cliente' },
        { key: 'nome', label: 'Nome' },
        { key: 'Ações', label: '', class: 'text-center' },
      ],
      visible: false,
    }
  },
  created() {
    if (this.id) {
      this.setPerson()
    }
  },
  methods: {
    modal() {
      this.visible ? (this.visible = false) : (this.visible = true)
    },
    onChangePerson(value) {
      this.model = value.id + ' - ' + value.nome
      this.$emit('onChangePerson', value)
    },
    async filtrar() {
      this.query = qs.stringify(this.form)
      var http = new service(
        `default/FIN_CLIENTE/search/params?limit=50&${this.query}`,
      )
      await http
        .find()
        .then((resp) => {
          this.items = resp.data.response
          this.key++
        })
        .catch(() => {})
    },
    async setPerson() {
      this.query = qs.stringify(this.form)
      var http = new service(
        `default/FIN_CLIENTE/search/params?limit=1&id=${this.id}`,
      )
      await http.find().then((resp) => {
        this.model =
          resp.data.response[0].id + ' - ' + resp.data.response[0].nome
      })
    },
    clearPerson() {
      this.model = null
    },
  },
}
</script>
